export const CARTESIAN = "cartesian";
export const PLAN_POSITIONING = "planPositioning";
export const FILE = "file";
export const FORM = "form";
export const GPS = "gps";
export const IMAGE = "image";
export const VALIDATION = "validation";

export const DATASET_TYPES = [
  CARTESIAN,
  PLAN_POSITIONING,
  FILE,
  FORM,
  GPS,
  IMAGE,
  VALIDATION,
] as const;
